<template>
  <div>
    <v-row class="mt-4 mb-8 pl-2" align="center">
      <v-icon large>mdi-phone-message</v-icon>
      <h2 class="text-h5 pl-2">Módulo Central de Atendimento</h2>
    </v-row>
    <v-row no-gutters>
      <div class="text-h6">Cadastro de Operadores</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoCadastroOperadores"
          :items="permissionsCadastroOperadores"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Cadastro de Pausas</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoCadastroPausas"
          :items="permissionsCadastroPausas"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Cadastro de Filas</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoCadastroFilas"
          :items="permissionsCadastroFilas"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Cadastro de Departamentos</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          dense
          v-model="selecionadoCadastroDepartamentos"
          :items="permissionsCadastroDepartamento"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Relatório de Operador</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoRelatorioOperador"
          :items="permissionsRelatorioOperador"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
      <!-- <v-col>
        <v-select
          dense
          v-model="selecionadoRelatorioOperadorHistorico"
          :items="permissionsRelatorioOperadorHistorico"
          label="Selecione o nível de permissão de histórico"
          :disabled="
            (selecionadoRelatorioOperador ===
              dictionaryRoles.callCenterRelatorioOperadorTotal.id ||
              selecionadoRelatorioOperador === null) ||
              permissaoVisualizar ||
              id == 1
          "
          outlined
          class="mt-3"
        />
      </v-col> -->
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Relatório de Fila</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoRelatorioFila"
          :items="permissionsRelatorioFila"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
      <!-- <v-col>
        <v-select
          dense
          v-model="selecionadoRelatorioFilaHistorico"
          :items="permissionsRelatorioFilaHistorico"
          label="Selecione o nível de permissão de histórico"
          :disabled="
            (selecionadoRelatorioFila ===
              dictionaryRoles.callCenterRelatorioFilaTotal.id ||
              selecionadoRelatorioFila === null) ||
              permissaoVisualizar ||
              id == 1
          "
          outlined
          class="mt-3"
        />
      </v-col> -->
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Relatório de Disponibilidade</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoRelatorioDisponibilidade"
          :items="permissionsRelatorioDisponibilidade"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Monitor de Filas</div>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoMonitorFilas"
          :items="permissionsMonitorFilas"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
      <v-col>
        <v-select
          dense
          v-model="selecionadoMonitorFilasFuncionalidades"
          :items="permissionsMonitorFilasFuncionalidades"
          label="Selecione as funcionalidades permitidas"
          :disabled="
            selecionadoMonitorFilas === null ||
              selecionadoMonitorFilas ===
                dictionaryRoles.callCenterMonitorTotal.id ||
              permissaoVisualizar ||
              id == 1
          "
          outlined
          multiple
          class="mt-3"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Manutenção de Operadores</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoManutencaoOperadores"
          :items="permissionsManutencaoOperadores"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Monitor de Operadores</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoMonitorOperador"
          :items="permissionsMonitorOperador"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
      <v-col>
        <v-select
          dense
          v-model="selecionadoMonitorOperadorFuncionalidades"
          :items="permissionsMonitorOperadorFuncionalidades"
          label="Selecione as funcionalidades permitidas"
          :disabled="
            selecionadoMonitorOperador === null ||
              selecionadoMonitorOperador ===
                dictionaryRoles.callCenterMonitorOperadorTotal.id ||
              permissaoVisualizar ||
              id == 1
          "
          outlined
          multiple
          class="mt-3"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Manutenção do Monitor de Operadores</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoConfiguracaoMonitorOperador"
          :items="permissionsConfiguracaoMonitorOperador"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <!-- Selects Gerais -->
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Operadores</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          outlined
          label="Operadores"
          v-model="selectedOperadores"
          :items="operadores"
          multiple
          class="mt-2"
          :disabled="
            (selecionadoCadastroOperadores !==
              dictionaryRoles.callCenterCadastroOperadorVisualizarCondicionado
                .id &&
              selecionadoCadastroOperadores !==
                dictionaryRoles.callCenterCadastroOperadorEditarCondicionado
                  .id &&
              selecionadoRelatorioOperador !==
                dictionaryRoles
                  .callCenterRelatorioOperadorVisualizarCondicionado.id &&
              selecionadoRelatorioOperador !==
                dictionaryRoles.callCenterRelatorioOperadorOuvirGravacao.id &&
              selecionadoRelatorioDisponibilidade !==
                dictionaryRoles.callCenterRelatorioDisponibilidadeVisualizarCondicionado.id &&
              selecionadoMonitorOperador !==
                dictionaryRoles.callCenterMonitorOperadorVisualizarCondicionado.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption">
                (+{{ selectedOperadores.length - 1 }})
              </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleOperadores">
              <v-list-item-action>
                <v-icon
                  :color="
                    selectedOperadores.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ iconOperadores }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Filas</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          outlined
          label="Filas"
          v-model="selectedFilas"
          :items="filas"
          multiple
          class="mt-2"
          :disabled="
            (selecionadoCadastroFilas !==
              dictionaryRoles.callCenterCadastroFilaVisualizarCondicionado.id &&
              selecionadoCadastroFilas !==
                dictionaryRoles.callCenterCadastroFilaEditarCondicionado.id &&
              selecionadoRelatorioFila !==
                dictionaryRoles.callCenterRelatorioFilaVisualizarCondicionado
                  .id &&
              selecionadoRelatorioFila !==
                dictionaryRoles.callCenterRelatorioFilaOuvirGravacao.id &&
              selecionadoMonitorFilas !==
                dictionaryRoles.callCenterMonitorVisualizar.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption"> (+{{ selectedFilas.length - 1 }}) </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleFilas">
              <v-list-item-action>
                <v-icon
                  :color="selectedFilas.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ iconFilas }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

   <v-row no-gutters class="mt-n2">
      <div class="text-h6">Departamentos</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          outlined
          label="Departamentos"
          v-model="selectedDepartamentos"
          :items="departamentos"
          multiple
          class="mt-2"
          :disabled="
            selecionadoCadastroDepartamentos !==
              dictionaryRoles.callCenterCadastroDepartamentosVisualizarCondicionado.id &&
            selecionadoCadastroDepartamentos !==
              dictionaryRoles.callCenterCadastroDepartamentosEditarCondicionado.id &&
            selecionadoRelatorioOperador !==
              dictionaryRoles.callCenterRelatorioOperadorVisualizarCondicionado.id &&
            selecionadoRelatorioOperador !==
              dictionaryRoles.callCenterRelatorioOperadorOuvirGravacao.id &&
            selecionadoRelatorioDisponibilidade !==
              dictionaryRoles.callCenterRelatorioDisponibilidadeVisualizarCondicionado.id &&
            selecionadoMonitorOperador !==
              dictionaryRoles.callCenterMonitorOperadorVisualizarCondicionado.id
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption"> (+{{ selectedDepartamentos.length - 1 }}) </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleDepartamento">
              <v-list-item-action>
                <v-icon
                  :color="selectedDepartamentos.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ iconDepartamentos }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

  
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { registerVuexModule } from "@/utils/vuexUtils";
import { addAndRemovePermissions } from "../_utils/addAndRemovePermissions";
import { dictionaryRoles } from "../_utils/dictionaryRoles";

import roleStore from "../_store";

export default {
  data: () => ({
    dictionaryRoles: dictionaryRoles,
    permissaoVisualizar: false,
    initPermissoes: false,
    // Select Operadores
    operadores: [],
    selectedOperadores: [],
    initiatedOperadores: false,
    // Select Fila
    filas: [],
    selectedFilas: [],
    initiatedFilas: false,
    //Select Departamentos
    departamentos: [],
    selectedDepartamentos:[],
    initiatedDepartamentos: false,
    // Cadastro de operadores
    permissionsCadastroOperadores: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.callCenterCadastroOperadorVisualizarCondicionado
            .description,
        value:
          dictionaryRoles.callCenterCadastroOperadorVisualizarCondicionado.id,
      },
      {
        text:
          dictionaryRoles.callCenterCadastroOperadorEditarCondicionado
            .description,
        value: dictionaryRoles.callCenterCadastroOperadorEditarCondicionado.id,
      },
      {
        text: dictionaryRoles.callCenterCadastroOperadorTotal.description,
        value: dictionaryRoles.callCenterCadastroOperadorTotal.id,
      },
    ],
    selecionadoCadastroOperadores: null,
    // Cadastro de pausas
    permissionsCadastroPausas: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.callCenterCadastroPausaVisualizar.description,
        value: dictionaryRoles.callCenterCadastroPausaVisualizar.id,
      },
      {
        text: dictionaryRoles.callCenterCadastroPausaEditar.description,
        value: dictionaryRoles.callCenterCadastroPausaEditar.id,
      },
      {
        text: dictionaryRoles.callCenterCadastroPausaTotal.description,
        value: dictionaryRoles.callCenterCadastroPausaTotal.id,
      },
    ],
    selecionadoCadastroPausas: null,
    // Cadastro de Filas
    permissionsCadastroFilas: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.callCenterCadastroFilaVisualizarCondicionado
            .description,
        value: dictionaryRoles.callCenterCadastroFilaVisualizarCondicionado.id,
      },
      {
        text:
          dictionaryRoles.callCenterCadastroFilaEditarCondicionado.description,
        value: dictionaryRoles.callCenterCadastroFilaEditarCondicionado.id,
      },
      {
        text: dictionaryRoles.callCenterCadastroFilaTotal.description,
        value: dictionaryRoles.callCenterCadastroFilaTotal.id,
      },
    ],
    selecionadoCadastroFilas: null,

    //Cadastro de departamento
    permissionsCadastroDepartamento: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.callCenterCadastroDepartamentosVisualizarCondicionado
            .description,
        value: dictionaryRoles.callCenterCadastroDepartamentosVisualizarCondicionado.id,
      },
      {
        text:
          dictionaryRoles.callCenterCadastroDepartamentosEditarCondicionado.description,
        value: dictionaryRoles.callCenterCadastroDepartamentosEditarCondicionado.id,
      },
      {
        text: dictionaryRoles.callCenterCadastroDepartamentosTotal.description,
        value: dictionaryRoles.callCenterCadastroDepartamentosTotal.id,
      },
    ],
    selecionadoCadastroDepartamentos: null,


    //Relatorio Operador
    permissionsRelatorioOperador: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.callCenterRelatorioOperadorVisualizarCondicionado
            .description,
        value:
          dictionaryRoles.callCenterRelatorioOperadorVisualizarCondicionado.id,
      },
      {
        text:
          dictionaryRoles.callCenterRelatorioOperadorOuvirGravacao.description,
        value: dictionaryRoles.callCenterRelatorioOperadorOuvirGravacao.id,
      },
      {
        text: dictionaryRoles.callCenterRelatorioOperadorTotal.description,
        value: dictionaryRoles.callCenterRelatorioOperadorTotal.id,
      },
    ],
    selecionadoRelatorioOperador: null,
    // Relatório de operador - Historico
    permissionsRelatorioOperadorHistorico: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.callCenterRelatorioOperadorHistorico.description,
        value: dictionaryRoles.callCenterRelatorioOperadorHistorico.id,
      },
      {
        text:
          dictionaryRoles.callCenterRelatorioOperadorOuvirGravacaoHistorico
            .description,
        value:
          dictionaryRoles.callCenterRelatorioOperadorOuvirGravacaoHistorico.id,
      },
    ],
    selecionadoRelatorioOperadorHistorico: null,
    // Relatório de fila
    permissionsRelatorioFila: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.callCenterRelatorioFilaVisualizarCondicionado
            .description,
        value: dictionaryRoles.callCenterRelatorioFilaVisualizarCondicionado.id,
      },
      {
        text: dictionaryRoles.callCenterRelatorioFilaOuvirGravacao.description,
        value: dictionaryRoles.callCenterRelatorioFilaOuvirGravacao.id,
      },
      {
        text: dictionaryRoles.callCenterRelatorioFilaTotal.description,
        value: dictionaryRoles.callCenterRelatorioFilaTotal.id,
      },
    ],
    selecionadoRelatorioFila: null,
    // Relatório de fila - Historico
    permissionsRelatorioFilaHistorico: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.callCenterRelatorioFilaHistorico.description,
        value: dictionaryRoles.callCenterRelatorioFilaHistorico.id,
      },
      {
        text:
          dictionaryRoles.callCenterRelatorioFilaOuvirGravacaoHistorico
            .description,
        value: dictionaryRoles.callCenterRelatorioFilaOuvirGravacaoHistorico.id,
      },
    ],
    selecionadoRelatorioFilaHistorico: null,
    // Relatório de disponibilidade
    permissionsRelatorioDisponibilidade: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles
            .callCenterRelatorioDisponibilidadeVisualizarCondicionado
            .description,
        value:
          dictionaryRoles
            .callCenterRelatorioDisponibilidadeVisualizarCondicionado.id,
      },
      {
        text:
          dictionaryRoles.callCenterRelatorioDisponibilidadeTotal.description,
        value: dictionaryRoles.callCenterRelatorioDisponibilidadeTotal.id,
      },
    ],
    selecionadoRelatorioDisponibilidade: null,
    // Monitor de Filas
    permissionsMonitorFilas: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.callCenterMonitorVisualizar.description,
        value: dictionaryRoles.callCenterMonitorVisualizar.id,
      },
      {
        text: dictionaryRoles.callCenterMonitorTotal.description,
        value: dictionaryRoles.callCenterMonitorTotal.id,
      },
    ],
    selecionadoMonitorFilas: null,
    // Monitor de filas - Funcionalidades
    permissionsMonitorFilasFuncionalidades: [
      {
        text: dictionaryRoles.callCenterMonitorPausaDespausa.description,
        value: dictionaryRoles.callCenterMonitorPausaDespausa.id,
      },
      {
        text:
          dictionaryRoles.callCenterMonitorAdicionarOperadorRemoverOperador
            .description,
        value:
          dictionaryRoles.callCenterMonitorAdicionarOperadorRemoverOperador.id,
      },
      {
        text: dictionaryRoles.callCenterMonitorDeslogarOperador.description,
        value: dictionaryRoles.callCenterMonitorDeslogarOperador.id,
      },
      {
        text: dictionaryRoles.callCenterMonitorOuvirOperador.description,
        value: dictionaryRoles.callCenterMonitorOuvirOperador.id,
      },
    ],
    selecionadoMonitorFilasFuncionalidades: [],
    // Manutenção de operadores
    permissionsManutencaoOperadores: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.callCenterManutencaoVisualizar.description,
        value: dictionaryRoles.callCenterManutencaoVisualizar.id,
      },
    ],
    selecionadoManutencaoOperadores: null,
    // Manutenção Monitor de operadores
    permissionsConfiguracaoMonitorOperador: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.callCenterConfiguracaoMonitorOperador.description,
        value: dictionaryRoles.callCenterConfiguracaoMonitorOperador.id,
      },
    ],
    selecionadoConfiguracaoMonitorOperador: null,
    permissionsMonitorOperadorFuncionalidades: [
      {
        text: dictionaryRoles.callCenterMonitorOperadorPausaDespausa.description,
        value: dictionaryRoles.callCenterMonitorOperadorPausaDespausa.id,
      },
      {
        text:
          dictionaryRoles.callCenterMonitorOperadorRemoverFila.description,
        value:
          dictionaryRoles.callCenterMonitorOperadorRemoverFila.id,
      },
      {
        text: dictionaryRoles.callCenterMonitorOperadorDeslogarOperador.description,
        value: dictionaryRoles.callCenterMonitorOperadorDeslogarOperador.id,
      },
      {
        text: dictionaryRoles.callCenterMonitorOperadorOuvirOperador.description,
        value: dictionaryRoles.callCenterMonitorOperadorOuvirOperador.id,
      },
    ],
    selecionadoMonitorOperadorFuncionalidades: [],
    // Monitor de Operadores
    permissionsMonitorOperador: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.callCenterMonitorOperadorVisualizarCondicionado.description,
        value: dictionaryRoles.callCenterMonitorOperadorVisualizarCondicionado.id,
      },
      {
        text: dictionaryRoles.callCenterMonitorOperadorTotal.description,
        value: dictionaryRoles.callCenterMonitorOperadorTotal.id,
      },
    ],
    selecionadoMonitorOperador: null,
  }),

  computed: {
    ...mapGetters("moduloPABXStepStore", [
      "getFilas",
      "getOperadores",
      "getSelectedOperadores",
      "getSelectedFilas",
      "getPermissoes",
      "getDepartamentos",
      "getSelectedDepartamentos",
    ]),

    todosOperadoresSelecionados() {
      return this.selectedOperadores.length === this.operadores.length;
    },
    algunsOperadoressSelecionados() {
      return (
        this.selectedOperadores.length > 0 && !this.todosOperadoresSelecionados
      );
    },
    iconOperadores() {
      if (this.todosOperadoresSelecionados) return "mdi-close-box";
      if (this.algunsOperadoressSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    todasFilasSelecionadas() {
      return this.selectedFilas.length === this.filas.length;
    },
    algumasFilasSelecionadas() {
      return this.selectedFilas.length > 0 && !this.todasFilasSelecionadas;
    },
    iconFilas() {
      if (this.todasFilasSelecionadas) return "mdi-close-box";
      if (this.algumasFilasSelecionadas) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    todosDepartamentosSelecionados() {
      return this.selectedDepartamentos.length === this.departamentos.length;
    },
    algunsDepartamentosSelecionados() {
      return this.selectedDepartamentos.length > 0 && !this.todosDepartamentosSelecionados;
    },
    iconDepartamentos() {
      if (this.todosDepartamentosSelecionados) return "mdi-close-box";
      if (this.algunsDepartamentosSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

  },

  async created() {
    this.initPermissoes = false;
    registerVuexModule(this.$store, "moduloPABXStepStore", roleStore);

    const verifyFilasVuex = this.getFilas.length;
    const verifyOperadoresVuex = this.getOperadores.length;
    const verifyDepartamentosVuex = this.getDepartamentos.length;

    if (verifyFilasVuex === 0 && verifyOperadoresVuex === 0 && verifyDepartamentosVuex === 0) {
      await Promise.all([this.listAllFilas(), this.listAllOperadores(), this.listaAllDepartamentos()]);
    } else if (verifyFilasVuex !== 0 && verifyOperadoresVuex === 0) {
      await this.listAllOperadores();
    } else if (verifyFilasVuex === 0 && verifyOperadoresVuex !== 0) {
      await this.listAllFilas();
    }else if (verifyDepartamentosVuex === 0){
      await this.listaAllDepartamentos();
    }
    this.getDepartamentos.sort((a,b) => a.codigo - b.codigo);

    this.departamentos = this.getDepartamentos.map(departament =>({
      text: `${departament.codigo} - ${departament.description}`,
      value: departament._id,
    }));
    
    this.filas = this.getFilas.map((fila) => ({
      text: fila.description,
      value: fila._id,
    }));
    this.operadores = this.getOperadores.map((operador) => ({
      text: `${operador.numero} - ${operador.usuario}`,
      value: operador._id,
    }));

    this.selectedDepartamentos = this.getSelectedDepartamentos;
    this.selectedFilas = this.getSelectedFilas;
    this.selectedOperadores = this.getSelectedOperadores;

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (
      arrayPermissions.includes(
        process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR
      )
    ) {
      this.permissaoVisualizar = true;
    }
  },

  methods: {
    ...mapActions("moduloPABXStepStore", [
      "listAllFilas",
      "listAllOperadores",
      "setSelectedFilas",
      "setSelectedOperadores",
      "addPermissionsID",
      "deletePermissionsID",
      "listaAllDepartamentos",
      "setSelectedDepartamentos",
    ]),
    ...obtainUserPermissions,
    ...addAndRemovePermissions,

    toggleOperadores() {
      this.$nextTick(() => {
        if (this.todosOperadoresSelecionados) {
          this.selectedOperadores.splice(0);
        } else {
          this.selectedOperadores.splice(0);
          this.selectedOperadores = this.operadores.map(
            (operador) => operador.value
          );
        }
      });
    },

    toggleFilas() {
      this.$nextTick(() => {
        if (this.todasFilasSelecionadas) {
          this.selectedFilas.splice(0);
        } else {
          this.selectedFilas.splice(0);
          this.selectedFilas = this.filas.map((fila) => fila.value);
        }
      });
    },
    
    toggleDepartamento() {
      this.$nextTick(() => {
        if (this.todosDepartamentosSelecionados) {
          this.selectedDepartamentos.splice(0);
        } else {
          this.selectedDepartamentos.splice(0);
          this.selectedDepartamentos = this.departamentos.map((departament) => departament.value);
        }
      });
    },
    limpaDepartamentos(){
      return this.selectedDepartamentos.splice(0);
    },
    limpaFilas(){
      return this.selectedFilas.splice(0);
    }
  },

  watch: {
    selectedFilas: {
      deep: true,
      async handler() {
        await this.setSelectedFilas(this.selectedFilas);
      },
    },
    selectedDepartamentos: {
      deep: true,
      async handler() {
        await this.setSelectedDepartamentos(this.selectedDepartamentos);
      },
    },
    
    selectedOperadores: {
      deep: true,
      async handler() {
        await this.setSelectedOperadores(this.selectedOperadores);
      },
    },
    getSelectedFilas: {
      deep: true,
      handler() {
        if (!this.initiatedFilas) {
          this.selectedFilas = [...this.getSelectedFilas];
          this.initiatedFilas = true;
        }
      },
    },
    getSelectedDepartamentos: {
      deep: true,
      handler() {
        if (!this.initiatedDepartamentos) {
          this.selectedDepartamentos = [...this.getSelectedDepartamentos];
          this.initiatedDepartamentos = true;
        }
      },
    },
    getSelectedOperadores: {
      deep: true,
      handler() {
        if (!this.initiatedOperadores) {
          this.selectedOperadores = [...this.getSelectedOperadores];
          this.initiatedOperadores = true;
        }
      },
    },
    // Monitora permissoes
    getPermissoes: {
      deep: true,
      handler(newValue) {
        if (!this.initPermissoes) {
          this.initPermissoes = true;
          // Cadastro de operadores
          if (
            newValue.includes(
              dictionaryRoles.callCenterCadastroOperadorVisualizarCondicionado
                .id
            )
          ) {
            this.selecionadoCadastroOperadores =
              dictionaryRoles.callCenterCadastroOperadorVisualizarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterCadastroOperadorEditarCondicionado.id
            )
          ) {
            this.selecionadoCadastroOperadores =
              dictionaryRoles.callCenterCadastroOperadorEditarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterCadastroOperadorTotal.id
            )
          ) {
            this.selecionadoCadastroOperadores =
              dictionaryRoles.callCenterCadastroOperadorTotal.id;
          }
          // Cadastro de Pausas
          if (
            newValue.includes(
              dictionaryRoles.callCenterCadastroPausaVisualizar.id
            )
          ) {
            this.selecionadoCadastroPausas =
              dictionaryRoles.callCenterCadastroPausaVisualizar.id;
          } else if (
            newValue.includes(dictionaryRoles.callCenterCadastroPausaEditar.id)
          ) {
            this.selecionadoCadastroPausas =
              dictionaryRoles.callCenterCadastroPausaEditar.id;
          } else if (
            newValue.includes(dictionaryRoles.callCenterCadastroPausaTotal.id)
          ) {
            this.selecionadoCadastroPausas =
              dictionaryRoles.callCenterCadastroPausaTotal.id;
          }
          // Cadastro de Filas
          if (
            newValue.includes(
              dictionaryRoles.callCenterCadastroFilaVisualizarCondicionado.id
            )
          ) {
            this.selecionadoCadastroFilas =
              dictionaryRoles.callCenterCadastroFilaVisualizarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterCadastroFilaEditarCondicionado.id
            )
          ) {
            this.selecionadoCadastroFilas =
              dictionaryRoles.callCenterCadastroFilaEditarCondicionado.id;
          } else if (
            newValue.includes(dictionaryRoles.callCenterCadastroFilaTotal.id)
          ) {
            this.selecionadoCadastroFilas =
              dictionaryRoles.callCenterCadastroFilaTotal.id;
          }
          //Cadastro de Departamentos
          if (
            newValue.includes(
              dictionaryRoles.callCenterCadastroDepartamentosVisualizarCondicionado.id
            )
          ) {
            this.selecionadoCadastroDepartamentos =
              dictionaryRoles.callCenterCadastroDepartamentosVisualizarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterCadastroDepartamentosEditarCondicionado.id
            )
          ) {
            this.selecionadoCadastroDepartamentos =
              dictionaryRoles.callCenterCadastroDepartamentosEditarCondicionado.id;
          } else if (
            newValue.includes(dictionaryRoles.callCenterCadastroDepartamentosTotal.id)
          ) {
            this.selecionadoCadastroDepartamentos =
              dictionaryRoles.callCenterCadastroDepartamentosTotal.id;
          }
          // Relatório de Operador
          if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioOperadorVisualizarCondicionado
                .id
            )
          ) {
            this.selecionadoRelatorioOperador =
              dictionaryRoles.callCenterRelatorioOperadorVisualizarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioOperadorOuvirGravacao.id
            )
          ) {
            this.selecionadoRelatorioOperador =
              dictionaryRoles.callCenterRelatorioOperadorOuvirGravacao.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioOperadorTotal.id
            )
          ) {
            this.selecionadoRelatorioOperador =
              dictionaryRoles.callCenterRelatorioOperadorTotal.id;
          }
          // Relatório de Operador - Historico
          if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioOperadorHistorico.id
            )
          ) {
            this.selecionadoRelatorioOperadorHistorico =
              dictionaryRoles.callCenterRelatorioOperadorHistorico.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioOperadorOuvirGravacaoHistorico
                .id
            )
          ) {
            this.selecionadoRelatorioOperadorHistorico =
              dictionaryRoles.callCenterRelatorioOperadorOuvirGravacaoHistorico.id;
          }
          // Relatório de Fila
          if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioFilaVisualizarCondicionado.id
            )
          ) {
            this.selecionadoRelatorioFila =
              dictionaryRoles.callCenterRelatorioFilaVisualizarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioFilaOuvirGravacao.id
            )
          ) {
            this.selecionadoRelatorioFila =
              dictionaryRoles.callCenterRelatorioFilaOuvirGravacao.id;
          } else if (
            newValue.includes(dictionaryRoles.callCenterRelatorioFilaTotal.id)
          ) {
            this.selecionadoRelatorioFila =
              dictionaryRoles.callCenterRelatorioFilaTotal.id;
          }
          // Relatório de Operador - Historico
          if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioFilaHistorico.id
            )
          ) {
            this.selecionadoRelatorioFilaHistorico =
              dictionaryRoles.callCenterRelatorioFilaHistorico.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioFilaOuvirGravacaoHistorico.id
            )
          ) {
            this.selecionadoRelatorioFilaHistorico =
              dictionaryRoles.callCenterRelatorioFilaOuvirGravacaoHistorico.id;
          }
          // Relatório de Disponibilidade
          if (
            newValue.includes(
              dictionaryRoles
                .callCenterRelatorioDisponibilidadeVisualizarCondicionado.id
            )
          ) {
            this.selecionadoRelatorioDisponibilidade =
              dictionaryRoles.callCenterRelatorioDisponibilidadeVisualizarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.callCenterRelatorioDisponibilidadeTotal.id
            )
          ) {
            this.selecionadoRelatorioDisponibilidade =
              dictionaryRoles.callCenterRelatorioDisponibilidadeTotal.id;
          }
          // Monitor de Filas
          if (
            newValue.includes(dictionaryRoles.callCenterMonitorVisualizar.id)
          ) {
            this.selecionadoMonitorFilas =
              dictionaryRoles.callCenterMonitorVisualizar.id;
          } else if (
            newValue.includes(dictionaryRoles.callCenterMonitorTotal.id)
          ) {
            this.selecionadoMonitorFilas =
              dictionaryRoles.callCenterMonitorTotal.id;
          }
          // Monitor de Filas - Funcionalidades
          if (
            newValue.includes(dictionaryRoles.callCenterMonitorPausaDespausa.id)
          ) {
            this.selecionadoMonitorFilasFuncionalidades.push(
              dictionaryRoles.callCenterMonitorPausaDespausa.id
            );
          }
          if (
            newValue.includes(
              dictionaryRoles.callCenterMonitorAdicionarOperadorRemoverOperador
                .id
            )
          ) {
            this.selecionadoMonitorFilasFuncionalidades.push(
              dictionaryRoles.callCenterMonitorAdicionarOperadorRemoverOperador
                .id
            );
          }
          if (
            newValue.includes(
              dictionaryRoles.callCenterMonitorDeslogarOperador.id
            )
          ) {
            this.selecionadoMonitorFilasFuncionalidades.push(
              dictionaryRoles.callCenterMonitorDeslogarOperador.id
            );
          }
          if (
            newValue.includes(dictionaryRoles.callCenterMonitorOuvirOperador.id)
          ) {
            this.selecionadoMonitorFilasFuncionalidades.push(
              dictionaryRoles.callCenterMonitorOuvirOperador.id
            );
          }
          // Monitor de Operador - Funcionalidades
          if (
            newValue.includes(dictionaryRoles.callCenterMonitorOperadorPausaDespausa.id)
          ) {
            this.selecionadoMonitorOperadorFuncionalidades.push(
              dictionaryRoles.callCenterMonitorOperadorPausaDespausa.id
            );
          }
          if (
            newValue.includes(
              dictionaryRoles.callCenterMonitorOperadorRemoverFila
                .id
            )
          ) {
            this.selecionadoMonitorOperadorFuncionalidades.push(
              dictionaryRoles.callCenterMonitorOperadorRemoverFila
                .id
            );
          }
          if (
            newValue.includes(
              dictionaryRoles.callCenterMonitorOperadorDeslogarOperador.id
            )
          ) {
            this.selecionadoMonitorOperadorFuncionalidades.push(
              dictionaryRoles.callCenterMonitorOperadorDeslogarOperador.id
            );
          }
          if (
            newValue.includes(dictionaryRoles.callCenterMonitorOperadorOuvirOperador.id)
          ) {
            this.selecionadoMonitorOperadorFuncionalidades.push(
              dictionaryRoles.callCenterMonitorOperadorOuvirOperador.id
            );
          }

        }

        // Manutenção de Operadores
        if (
          newValue.includes(dictionaryRoles.callCenterManutencaoVisualizar.id)
        ) {
          this.selecionadoManutencaoOperadores =
            dictionaryRoles.callCenterManutencaoVisualizar.id;
        }
        // Configuração Monitor Operador
        if (
          newValue.includes(dictionaryRoles.callCenterConfiguracaoMonitorOperador.id)
        ) {
          this.selecionadoConfiguracaoMonitorOperador =
            dictionaryRoles.callCenterConfiguracaoMonitorOperador.id;
        }
        // Monitor Operador
        if (
          newValue.includes(dictionaryRoles.callCenterMonitorOperadorVisualizarCondicionado.id)
        ) {
          this.selecionadoMonitorOperador =
            dictionaryRoles.callCenterMonitorOperadorVisualizarCondicionado.id;
        }
        if (
          newValue.includes(
            dictionaryRoles.callCenterMonitorOperadorTotal.id
          )
        ) {
          this.selecionadoMonitorOperador =
            dictionaryRoles.callCenterMonitorOperadorTotal.id;
        }
      },
    },
    //Monitora Selects
    selecionadoCadastroOperadores: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoCadastroPausas: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoCadastroFilas: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },

    selecionadoCadastroDepartamentos: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },

    //Relatorios
    selecionadoRelatorioOperador: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue === dictionaryRoles.callCenterRelatorioOperadorTotal.id) {
          this.selecionadoRelatorioOperadorHistorico =
            dictionaryRoles.callCenterRelatorioOperadorOuvirGravacaoHistorico.id;
        } else if (newValue === null) {
          this.selecionadoRelatorioOperadorHistorico = null;
        }
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoRelatorioOperadorHistorico: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoRelatorioFila: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue === dictionaryRoles.callCenterRelatorioFilaTotal.id) {
          this.selecionadoRelatorioFilaHistorico =
            dictionaryRoles.callCenterRelatorioFilaOuvirGravacaoHistorico.id;
        } else if (newValue === null) {
          this.selecionadoRelatorioFilaHistorico = null;
        }
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoRelatorioFilaHistorico: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoRelatorioDisponibilidade: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoMonitorFilas: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue === dictionaryRoles.callCenterMonitorTotal.id) {
          this.selecionadoMonitorFilasFuncionalidades = [
            dictionaryRoles.callCenterMonitorPausaDespausa.id,
            dictionaryRoles.callCenterMonitorAdicionarOperadorRemoverOperador
              .id,
            dictionaryRoles.callCenterMonitorDeslogarOperador.id,
            dictionaryRoles.callCenterMonitorOuvirOperador.id,
          ];
        } else if (newValue === null) {
          this.selecionadoMonitorFilasFuncionalidades = [];
        }
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoMonitorFilasFuncionalidades: {
      deep: true,
      handler(newValue, oldValue) {
        oldValue.forEach((value) => {
          this.deletePermissionsID(value);
        });
        newValue.forEach((value) => {
          this.addPermissionsID(value);
        });
      },
    },
    selecionadoManutencaoOperadores: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoConfiguracaoMonitorOperador: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoMonitorOperador:{
      deep: true,
     handler(newValue, oldValue) {
        if (newValue === dictionaryRoles.callCenterMonitorOperadorTotal.id) {
          this.selecionadoMonitorOperadorFuncionalidades = [
            dictionaryRoles.callCenterMonitorOperadorPausaDespausa.id,
            dictionaryRoles.callCenterMonitorOperadorRemoverFila.id,
            dictionaryRoles.callCenterMonitorOperadorDeslogarOperador.id,
            dictionaryRoles.callCenterMonitorOperadorOuvirOperador.id,
          ];
        } else if (newValue === null) {
          this.selecionadoMonitorOperadorFuncionalidades = [];
        }
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoMonitorOperadorFuncionalidades: {
      deep: true,
      handler(newValue, oldValue) {
        oldValue.forEach((value) => {
          this.deletePermissionsID(value);
        });
        newValue.forEach((value) => {
          this.addPermissionsID(value);
        });
      },
    },
  },
};
</script>
